import { useMemo } from 'react';
import { Box, Button, Link, Stack } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useMe } from '@hooks/getQueries';
import useSession from '@hooks/useSession';
import { signOutAndRedirect } from '@utils/authSession';
import WorkspaceActivationContent from '@components/workspace/WorkspaceActivationContent';

const WorkspaceActivation = () => {
  const [searchParams] = useSearchParams();
  const { isAuthenticated, handleLogout } = useSession();
  const { data: me } = useMe(isAuthenticated);

  const queryData = useMemo(() => {
    return {
      workspace_id: searchParams.get('workspace_id') || '',
      workspace_name: searchParams.get('workspace_name') || '',
      user_name: searchParams.get('user_name') || '',
      user_email: searchParams.get('user_email') || '',
      company_name: searchParams.get('company_name') || '',
      role_title: searchParams.get('role_title') || '',
      source: searchParams.get('source') || document.referrer || 'direct',
      status: searchParams.get('status') || '',
      expired: searchParams.get('expired') === 'true',
    };
  }, [searchParams]);

  const isExpired = queryData.expired || queryData.status === 'expired';

  return (
    <Box
      sx={{ minHeight: '100vh', background: 'linear-gradient(135deg, #FFFFFF 0%, #F5F3FF 100%)' }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        spacing={2}
        sx={{ px: { xs: 3, md: 6 }, py: { xs: 3, md: 4 } }}
      >
        <Link
          href="https://qualz.ai"
          target="_blank"
          rel="noreferrer"
          underline="none"
          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        >
          <Box
            component="img"
            src="/images/logos/qualz-logo.png"
            alt="Qualz.ai"
            sx={{ height: 40 }}
          />
        </Link>
        {isAuthenticated && me && (
          <Button
            variant="text"
            onClick={() => {
              handleLogout();
              signOutAndRedirect('/signin');
            }}
          >
            Sign out
          </Button>
        )}
      </Stack>
      <WorkspaceActivationContent prefill={queryData} isExpired={isExpired} variant="embedded" />
    </Box>
  );
};

export default WorkspaceActivation;
